import { useSelector } from 'react-redux';
import { getVisiting } from '../../../redux/ducks/selections';
import { useModalActions } from '../../Hooks/useModalActions';

export const useEditVisitingMetadataAction = () => {
  const modalActions = useModalActions();
  const visiting = useSelector(state => getVisiting(state));

  return () => {
    modalActions.openModal('metadata_edit', visiting);
  };
};
